<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vx-card title="Relatório Anual">
      <div class="vx-row">
          <div class="vx-col md:w-1/2 w-1/2 mt-5">
          
          <h6 class="mb-2">Anos</h6>
          <div>
            <datepicker
              placeholder="Selecione o Ano"
              :language="languages['ptBR']"
              format="yyyy"
              v-model="year1"
              :minimumView="'year'" :maximumView="'year'"
            ></datepicker>
          </div>
        </div> 
         <div class="vx-col md:w-1/2 w-1/2 mt-5">
          
          <h6 class="mb-2">Ano</h6>
          <div>
            <datepicker
              placeholder="Selecione o Ano"
              :language="languages['ptBR']"
              format="yyyy"
              v-model="year2"
              :minimumView="'year'" :maximumView="'year'"
            ></datepicker>
          </div>
        </div> 
      </div>
      <div class="vx-row">
          <div class="vx-col md:w-1/2 w-1/2 mt-5">
          
          <h6 class="mb-2">Ano</h6>
          <div>
            <datepicker
              placeholder="Selecione o Ano"
              :language="languages['ptBR']"
              format="yyyy"
              v-model="year3"
              :minimumView="'year'" :maximumView="'year'"
            ></datepicker>
          </div>
        </div> 
         <div class="vx-col md:w-1/2 w-1/2 mt-5">
          
          <h6 class="mb-2">Ano</h6>
          <div>
            <datepicker
              placeholder="Selecione o Ano"
              :language="languages['ptBR']"
              format="yyyy"
              v-model="year4"
              :minimumView="'year'" :maximumView="'year'"
            ></datepicker>
          </div>
        </div> 
      </div>
      <br />
      <vs-button color="success" type="filled" @click="submit">Gerar</vs-button>
    </vx-card>
    <br />
    <br />
  </div>
</template>


<script>
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import { momentJS } from "@/helpers";
import axios from "axios";
import { baseApiUrl } from "@/global";

export default {
  components: {
    Datepicker,
    vSelect,
  },
  data() {
    return {
      year1: null,
      year2: null,
      year3: null,
      year4: null,
      languages: lang,
      customerSelected: [],
      userSelected: null,
      moment: null,
    };
  },
  computed: {
    getUsers() {
      return this.$store.state.usersFiltered;
    },
  },
  methods: {
    async submit() {
      let year1 = this.moment.formatYear(this.year1);
      let year2 = this.moment.formatYear(this.year2);  
      let year3 = this.moment.formatYear(this.year3);  
      let year4 = this.moment.formatYear(this.year4);  
      
    
      try {
        this.$vs.loading();
        let res = await axios.get(
          `${baseApiUrl}/equipmentOrder/reportByYears?year1=${year1}&year2=${year2}&year3=${year3}&year4=${year4}`,
         { responseType: "blob" }
        );
        
        let blob = new Blob([res.data], { type: "application/pdf" }),
        url = window.URL.createObjectURL(blob);
        window.open(url);
        
      } catch (error) {
        this.$vs.notify({
          title: "Erro", 
          text: "Não foi possivel salvar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    this.moment = momentJS();
    this.year1 = this.moment.getDateTimeLocal();
    this.year2 = this.moment.getDateTimeLocal();
    this.year3 = this.moment.getDateTimeLocal();
    this.year4 = this.moment.getDateTimeLocal();
  },
};
</script>

<style lang="scss">
</style>
